import { localizedText } from '../types/slide-doc';
import type { Beat } from '../types/slide-doc';

interface Props {
  beat: Beat;
  onTap: () => void;
}

export function TapToContinue({ beat, onTap }: Props) {
  const label = localizedText(beat.label) || 'Tap to continue';
  return (
    <button onClick={onTap} style={style} aria-label={label}>
      <span style={pulseRing} />
      <span style={pulseRing2} />
      <span style={core}>▶</span>
      <span style={labelStyle}>{label}</span>
    </button>
  );
}

const style: React.CSSProperties = {
  position: 'fixed',
  left: '50%',
  bottom: 120,
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '14px 28px 14px 22px',
  background: 'rgba(15,25,35,0.88)',
  color: '#fff',
  border: '1px solid rgba(245,184,0,0.4)',
  borderRadius: 999,
  cursor: 'pointer',
  fontFamily: 'Inter, sans-serif',
  fontSize: 16,
  fontWeight: 600,
  zIndex: 40,
  backdropFilter: 'blur(8px)',
};

const core: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: 18,
  background: '#F5B800',
  color: '#0F1923',
  fontSize: 14,
  fontWeight: 800,
};

const labelStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
};

const pulseRing: React.CSSProperties = {
  position: 'absolute',
  left: 22,
  top: '50%',
  width: 36,
  height: 36,
  borderRadius: 18,
  border: '2px solid #F5B800',
  transform: 'translateY(-50%)',
  animation: 'tap-pulse 1.6s ease-out infinite',
  pointerEvents: 'none',
};

const pulseRing2: React.CSSProperties = {
  ...pulseRing,
  animationDelay: '0.8s',
};
